module.exports = {"public_path":"view/","tech_api":"https://api.lab.3d-smile.com","client_api":"https://ru.service.3d-smile.com","type":"integrated"}


//////////////////
// WEBPACK FOOTER
// ./src/api.json
// module id = 40
// module chunks = 0